export const convertBase64 = (base64Content: string) => {
  if (base64Content === null || base64Content === undefined) {
    return '';
  }

  try {
    return window.atob(base64Content);
  } catch (e) {
    console.error(e);
    return 'Unable to convert content.';
  }
};
